exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ppvx_text-input___dMiXx {\n  width: 100%;\n  text-align: left!important;\n  float: left;\n}\n.searchBoxInput___3XiZc {\n  height: 100%;\n  border: none;\n}\n.searchBoxInput___3XiZc input {\n  height: 100%;\n  border: none;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/searchBox.less"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,2BAA2B;EAC3B,YAAY;CACb;AACD;EACE,aAAa;EACb,aAAa;CACd;AACD;EACE,aAAa;EACb,aAAa;CACd","file":"searchBox.less","sourcesContent":[".ppvx_text-input {\n  width: 100%;\n  text-align: left!important;\n  float: left;\n}\n.searchBoxInput {\n  height: 100%;\n  border: none;\n}\n.searchBoxInput input {\n  height: 100%;\n  border: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"ppvx_text-input": "ppvx_text-input___dMiXx",
	"searchBoxInput": "searchBoxInput___3XiZc"
};